import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "pair__card pair__card--light" };
const _hoisted_3 = { class: "pair__tag" };
const _hoisted_4 = { class: "pair__title" };
const _hoisted_5 = { class: "pair__visual" };
const _hoisted_6 = { class: "pair__card pair__card--accent" };
const _hoisted_7 = {
    key: 0,
    class: "pair__intro"
};
const _hoisted_8 = { class: "pair__body" };
const _hoisted_9 = { class: "pair__stat" };
const _hoisted_10 = { class: "pair__stat-value" };
const _hoisted_11 = { class: "pair__stat-label" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_reveal = _resolveDirective("reveal");
    return (_openBlock(), _createElementBlock("div", {
        id: _ctx.id,
        class: "pair"
    }, [
        _withDirectives((_openBlock(), _createElementBlock("article", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.tag), 1),
            _createElementVNode("h3", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.titlePre) + " ", 1),
                _createElementVNode("em", null, _toDisplayString(_ctx.titleItalic), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.titlePost), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "visual", {}, undefined, true)
            ])
        ])), [
            [_directive_reveal]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("article", _hoisted_6, [
            (_ctx.intro)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.intro), 1))
                : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.body), 1),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.stat), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.statLabel), 1)
            ])
        ])), [
            [_directive_reveal, { delay: 140 }]
        ])
    ], 8, _hoisted_1));
}
